import React, { Component } from "react";
import { Row, Col } from "reactstrap";

import { Route, Switch } from "react-router-dom";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import CardSchemesList from "./List";
import CardSchemeForm from "./Form";
import CardScheme from "./View";
import NotFound from "../NotFound";

import { PageHeader } from "../Shared";

import { cardSchemeActions } from "./actions/cardschemes.actions";

export class ManageCardSchemes extends Component {
  componentDidMount() {
    this.getCardSchemes();
  }

  getCardSchemes = () => {
    this.props.getCardSchemes();
  };

  render() {
    const { fetching, fetched, response, error, match } = this.props;

    return (
      <div className="CardSchemes">
        <Row>
          <Col>
            <PageHeader pageId="cardschemes" pageTitle="Manage Card Schemes" />
          </Col>
        </Row>

        <div className="content-wrapper">
          <Switch>
            <Route
              exact
              path={match.url}
              render={() => (
                <CardSchemesList
                  match={match}
                  data={response}
                  loadData={this.getCardSchemes}
                  fetching={fetching}
                  fetched={fetched}
                  error={error}
                />
              )}
            />
            <Route
              path={`${match.url}/list`}
              render={() => (
                <CardSchemesList
                  match={match}
                  data={response}
                  loadData={this.getCardSchemes}
                  fetching={fetching}
                  fetched={fetched}
                  error={error}
                />
              )}
            />
            <Route path={`${match.url}/add`} component={CardSchemeForm} />
            <Route path={`${match.url}/view/:id`} component={CardScheme} />
            <Route path={`${match.url}/edit/:id`} component={CardSchemeForm} />
            <Route component={NotFound} />
          </Switch>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { fetching, fetched, response, error } = state.cardSchemes;
  return {
    fetching,
    fetched,
    response,
    error
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getCardSchemes: bindActionCreators(
      cardSchemeActions.getAllCardSchemes,
      dispatch
    )
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageCardSchemes);
